export default "__VITE_ASSET__DTIwACtC__"